import { CallStatus } from '@/types';

export const CallStatusClassMap = {
    [CallStatus.ANSWERED]: 'bg-green-600',
    [CallStatus.NO_ANSWER]: 'bg-red-500',
    [CallStatus.BUSY]: 'bg-yellow-500',
    [CallStatus.DITCHED]: 'bg-gray-600',
    [CallStatus.ON_PROGRESS]: 'bg-gray-400',
};
